import { __decorate, __metadata } from 'tslib';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCInputModule } from '@wlp/ui-c-input';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';

let UiCCreatePasswordComponent = class UiCCreatePasswordComponent {
    constructor() {
        this.isBack = true;
        this.isPartner = true;
        this.onChange = new EventEmitter();
        this.passwordToggle = new EventEmitter();
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
        this.iconName = 'eye';
        this.iconNameConfirm = 'eye';
        this.passwordShow = false;
        this.passwordType = 'password';
        this.confirmPasswordType = 'password';
    }
    onChangeForm() {
        this.onChange.emit(this.formCreatePassword);
    }
    togglePassword(ev) {
        if (this.passwordShow) {
            this.passwordShow = false;
            if (ev === 'confirmPassword') {
                this.iconNameConfirm = 'eye';
                this.confirmPasswordType = 'password';
            }
            else {
                this.passwordType = 'password';
                this.iconName = 'eye';
            }
        }
        else {
            this.passwordShow = true;
            if (ev === 'confirmPassword') {
                this.iconNameConfirm = 'eye-off';
                this.confirmPasswordType = 'text';
            }
            else {
                this.passwordType = 'text';
                this.iconName = 'eye-off';
            }
        }
    }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        this.continue.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCCreatePasswordComponent.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCCreatePasswordComponent.prototype, "isPartner", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCreatePasswordComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCreatePasswordComponent.prototype, "companyName", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCreatePasswordComponent.prototype, "document", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCreatePasswordComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCreatePasswordComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCreatePasswordComponent.prototype, "identifier", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCreatePasswordComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCCreatePasswordComponent.prototype, "secondaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCCreatePasswordComponent.prototype, "formCreatePassword", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCCreatePasswordComponent.prototype, "errorMessages", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCreatePasswordComponent.prototype, "onChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCreatePasswordComponent.prototype, "passwordToggle", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCreatePasswordComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCreatePasswordComponent.prototype, "continue", void 0);
UiCCreatePasswordComponent = __decorate([
    Component({
        selector: 'ui-c-create-password',
        template: "<div class=\"animation-type\">\n  <ion-row class=\"ion-justify-content-left ion-align-items-center\">\n    <ui-c-header-onboarding [isBack]=\"isBack\" [isPartner]=\"isPartner\" [identifier]=\"identifier | wlpTranslate\"\n      [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\" [title]=\"title\" [description]=\"description\" [name]=\"name\"\n      [companyName]=\"companyName\" [document]=\"document\" [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\"\n      (back)=\"goBack()\">\n    </ui-c-header-onboarding>\n  </ion-row>\n  <ion-row [formGroup]=\"formCreatePassword\">\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <div class=\"detail-item\">\n        <ion-text class=\"ion-text-left\">\n          <p class=\"font-family-bold ion-no-margin margin-bottom color-primary c-text-input\">\n            {{ 'ONBORDING.V2.FORM.LABEL.PASSWORD' | wlpTranslate }}\n          </p>\n        </ion-text>\n        <ion-item class=\"c-input\">\n          <ion-input [type]=\"passwordType\" formControlName=\"password\" data-cy=\"onboarding-pf-password\"\n            class=\"c-input ion-input password\"\n            placeholder=\"{{ 'ONBORDING.V2.FORM.PLACEHOLDER.PASSWORD' | wlpTranslate }}\" minlength=\"8\"\n            onpaste=\"return false\" ondrop=\"return false\" autocomplete=\"off\" maxlength=\"50\">\n          </ion-input>\n          <button class=\"button-password\" ion-button icon-only clear item-right (click)=\"togglePassword('password')\">\n            <ion-icon slot=\"end\" [name]=\"iconName\"> </ion-icon>\n          </button>\n        </ion-item>\n      </div>\n    </ion-col>\n\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <div class=\"detail-item\">\n        <ion-text class=\"ion-text-left\">\n          <p class=\"font-family-bold ion-no-margin margin-bottom color-primary c-text-input\">\n            {{ 'ONBORDING.V2.FORM.LABEL.CONFIRM_PASSWORD' | wlpTranslate }}\n          </p>\n        </ion-text>\n        <ion-item class=\"c-input\">\n          <ion-input [type]=\"confirmPasswordType\" formControlName=\"confirmPassword\"\n            data-cy=\"onboarding-pf-confirmpassword\" class=\"c-input ion-input confirm-password\" onpaste=\"return false\"\n            ondrop=\"return false\" autocomplete=\"off\"\n            placeholder=\"{{ 'ONBORDING.V2.FORM.PLACEHOLDER.CONFIRM_PASSWORD' | wlpTranslate }}\" minlength=\"8\"\n            maxlength=\"50\">\n          </ion-input>\n          <button class=\"button-password\" ion-button icon-only clear item-right\n            (click)=\"togglePassword('confirmPassword')\">\n            <ion-icon slot=\"end\" [name]=\"iconNameConfirm\"> </ion-icon>\n          </button>\n        </ion-item>\n      </div>\n    </ion-col>\n  </ion-row>\n\n  <div class=\"message-erros\">\n    <ion-row class=\" ion-justify-content-left ion-align-items-center\">\n      <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n        <ion-item lines=\"none\" class=\"ion-item ion-align-items-center item-password ion-justify-content-center\">\n          <ion-icon name=\"checkmark-circle\" color=\"success\"\n            *ngIf=\"formCreatePassword.get('password').value.length >= 8\">\n          </ion-icon>\n          <ion-icon name=\"close-circle\" color=\"danger\" *ngIf=\"formCreatePassword.get('password').value.length < 8\">\n          </ion-icon>\n          <ion-label class=\"ion-label\">{{\n            'ONBORDING.V2.TEXT.TITLE.PASSWORD' | wlpTranslate: param\n            }}</ion-label>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n    <ion-row class=\" ion-justify-content-left ion-align-items-center\">\n      <ion-col [size]=\"12\" [sizeMd]=\"6\" [sizeSm]=\"6\" *ngFor=\"let error of errorMessages.password\">\n        <ion-item lines=\"none\" class=\"ion-item ion-align-items-center item-password ion-justify-content-center\">\n          <ion-icon name=\"checkmark-circle\" color=\"success\"\n            *ngIf=\"!formCreatePassword.get('password').hasError(error.type)\">\n          </ion-icon>\n          <ion-icon name=\"close-circle\" color=\"danger\" *ngIf=\"formCreatePassword.get('password').hasError(error.type)\">\n          </ion-icon>\n          <ion-label class=\"ion-label\" color=\"success\" *ngIf=\"!formCreatePassword.get('password').hasError(error.type)\">\n            {{ error.message | wlpTranslate: error?.param }}</ion-label>\n          <ion-label class=\"ion-label\" *ngIf=\"formCreatePassword.get('password').hasError(error.type)\">{{\n            error.message | wlpTranslate: error?.param\n            }}</ion-label>\n        </ion-item>\n      </ion-col>\n\n      <ion-col [size]=\"12\" [sizeMd]=\"6\" [sizeSm]=\"6\" *ngFor=\"let error of errorMessages.confirmPassword\">\n        <ion-item lines=\"none\" class=\"ion-item ion-align-items-center item-password ion-justify-content-center\">\n          <ion-icon name=\"checkmark-circle\" color=\"success\"\n            *ngIf=\"formCreatePassword.get('confirmPassword').value !== '' && formCreatePassword.get('confirmPassword').value === formCreatePassword.get('password').value\">\n          </ion-icon>\n          <ion-icon name=\"close-circle\" color=\"danger\"\n            *ngIf=\"formCreatePassword.get('confirmPassword').value == '' || formCreatePassword.get('confirmPassword').value !== formCreatePassword.get('password').value\">\n          </ion-icon>\n\n          <ion-label class=\"ion-label\" color=\"success\"\n            *ngIf=\"formCreatePassword.get('confirmPassword').value !== '' && formCreatePassword.get('confirmPassword').value === formCreatePassword.get('password').value\">\n            {{ error.message | wlpTranslate }}\n          </ion-label>\n          <ion-label class=\"ion-label\"\n            *ngIf=\"formCreatePassword.get('confirmPassword').value == '' || formCreatePassword.get('confirmPassword').value !== formCreatePassword.get('password').value\">\n            {{ error.message | wlpTranslate }}\n          </ion-label>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n  </div>\n  <ion-row class=\"ion-justify-content-left ion-margin-top ion-margin-bottom\">\n    <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\">\n      <ui-c-button data-cy=\"onboarding-createpassword-btn\" [disabled]=\"formCreatePassword.invalid\" expand=\"block\"\n        (click)=\"goContinue()\">\n        {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n      </ui-c-button>\n    </ion-col>\n  </ion-row>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCCreatePasswordComponent);

let UiCCreatePasswordModule = class UiCCreatePasswordModule {
};
UiCCreatePasswordModule = __decorate([
    NgModule({
        declarations: [UiCCreatePasswordComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            UiBsTranslateModule,
            UiCButtonModule,
            UiCHeaderOnboardingModule,
            UiCInputModule
        ],
        exports: [
            UiCCreatePasswordComponent
        ]
    })
], UiCCreatePasswordModule);

export { UiCCreatePasswordComponent, UiCCreatePasswordModule };
//# sourceMappingURL=wlp-ui-c-create-password.js.map
